export enum SourceType {
    Feed = 'feed',
    Udq = 'udq',
    LinkedRecord = 'linkedRecord'
}
